/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import ITipoContribuyente from 'Infotrack@Modelos/administracion/tipoContribuyente/entidades/tipoContribuyente';
import { AnyAction } from 'redux';

export interface IEstadoTipoContribuyente {
    estadoFormulario: boolean;
    entidadTipoContribuyente: ITipoContribuyente | null;
    recargarTabla: boolean;
    tipoFormulario: TipoFormulario;
}

export const estadoIncial: IEstadoTipoContribuyente = {
    entidadTipoContribuyente: null,
    estadoFormulario: false,
    recargarTabla: false,
    tipoFormulario: TipoFormulario.Creacion,
};

export enum acciones {
    CAMBIAR_ESTADO_FORMULARIO = 'CAMBIAR_ESTADO_FORMULARIO',
    RECARGAR_TABLA = 'RECARGAR_TABLA',
}

export const reductor = (estado: IEstadoTipoContribuyente, { type, payload }: AnyAction) => {
    switch (type) {
        case 'CAMBIAR_ESTADO_FORMULARIO': {
            return {
                ...estado,
                entidadTipoContribuyente: payload ? payload.entidadTipoContribuyente : null,
                estadoFormulario: !estado.estadoFormulario,
                tipoFormulario: payload ? payload.tipoFormulario : estado.tipoFormulario,
            };
        }
        case 'RECARGAR_TABLA':
            return {
                ...estado,
                recargarTabla: !estado.recargarTabla,
            };

        default:
            return estado;
    }
};
